module.exports = __webpack_public_path__ + "img/gcc_hogar.ca02d6f7.png";